import { render, staticRenderFns } from "./InvoiceOccasionRows.vue?vue&type=template&id=08ffd390&scoped=true&"
import script from "./InvoiceOccasionRows.vue?vue&type=script&lang=js&"
export * from "./InvoiceOccasionRows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ffd390",
  null
  
)

export default component.exports